import React, { useState, useEffect } from 'react';
import {
  Box,
  TextField,
  Typography,
  Button,
  Snackbar,
  Alert
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { _get, _post } from '../../Config/axiosInstance';

function EditOfferPage() {
  const { offerId } = useParams();

  console.log("ooferid",offerId)
  const navigate = useNavigate();

  const [offer, setOffer] = useState({
    offerName: '',
    offerexpiry: '',
    offerfooddiscount: '',
    offermovietickets: '',
    offerother: ''
  });

  const [alert, setAlert] = useState({ open: false, message: '', severity: 'success' });

  useEffect(() => {
    const fetchOffer = async () => {
      try {
        const res = await _get('/getoffers');
        const allOffers = res.data.data || [];
        const found = allOffers.find(o => `${o.offerId}` === offerId);

        if (found) {
          setOffer({
            offerName: found.offerName || '',
            offerexpiry: found.offerexpiry || '',
            offerfooddiscount: found.offerfooddiscount || '',
            offermovietickets: found.offermovietickets || '',
            offerother: found.offerother || ''
          });
        } else {
          setAlert({ open: true, message: 'Offer not found', severity: 'error' });
        }
      } catch (err) {
        console.error('Error fetching offers:', err);
        setAlert({ open: true, message: 'Failed to load offers', severity: 'error' });
      }
    };

    fetchOffer();
  }, [offerId]);

  const handleChange = (e) => {
    setOffer({ ...offer, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    const { offerName, offerexpiry, offerfooddiscount, offermovietickets, offerother } = offer;

    if (!offerName || !offerexpiry || !offerfooddiscount || !offermovietickets) {
      setAlert({ open: true, message: 'Please fill all required fields', severity: 'error' });
      return;
    }

    const payload = {
      offerId: parseInt(offerId),
      offerName,
      offerexpiry: parseInt(offerexpiry),
      offerfooddiscount: parseInt(offerfooddiscount),
      offermovietickets: parseInt(offermovietickets),
      offerother: offerother?.trim() === '' ? null : offerother
    };

    try {
      await _post(`/updateoffer`, payload);
      setAlert({ open: true, message: 'Offer updated successfully!', severity: 'success' });
      setTimeout(() => navigate('/offers'), 500);
    } catch (error) {
      console.error('Error updating offer:', error);
      setAlert({ open: true, message: 'Failed to update offer', severity: 'error' });
    }
  };

  return (
    <Box sx={{ maxWidth: 500, mx: 'auto', mt: 5, p: 3, boxShadow: 3, borderRadius: 2 }}>
      <Typography variant="h5" gutterBottom>
        Edit Offer
      </Typography>

      <TextField
        fullWidth
        label="Offer Name"
        name="offerName"
        value={offer.offerName}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        fullWidth
        label="Expires In (Months)"
        name="offerexpiry"
        type="number"
        value={offer.offerexpiry}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        fullWidth
        label="Food Discount (%)"
        name="offerfooddiscount"
        type="number"
        value={offer.offerfooddiscount}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        fullWidth
        label="Max Ticket Count"
        name="offermovietickets"
        type="number"
        value={offer.offermovietickets}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        fullWidth
        label="Other Offers"
        name="offerother"
        value={offer.offerother}
        onChange={handleChange}
        margin="normal"
      />

      <Button
        variant="contained"
        color="primary"
        fullWidth
        sx={{ mt: 2 }}
        onClick={handleSubmit}
      >
        Update Offer
      </Button>

      <Snackbar open={alert.open} autoHideDuration={3000} onClose={() => setAlert({ ...alert, open: false })}>
        <Alert severity={alert.severity} variant="filled">{alert.message}</Alert>
      </Snackbar>
    </Box>
  );
}

export default EditOfferPage;
